/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dynamic_Qr_Technology_For_PhysInputs */

const en_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic QR technology for physical branding, business cards, and direct placement.`)
};

const es_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnología QR dinámica para branding físico, tarjetas de visita y colocación directa.`)
};

const fr_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technologie QR dynamique pour le branding physique, les cartes de visite et le placement direct.`)
};

const de_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamische QR-Technologie für physisches Branding, Visitenkarten und direkte Platzierung.`)
};

const ja_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物理的なブランディング、名刺、直接配置のための動的QRテクノロジー。`)
};

const zh_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用于实体品牌、名片和直接投放的动态二维码技术。`)
};

const ar_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقنية QR ديناميكية للعلامات التجارية المادية، بطاقات العمل، والمواضع المباشرة.`)
};

const id_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teknologi QR dinamis untuk branding fisik, kartu nama, dan penempatan langsung.`)
};

const it_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologia QR dinamica per il branding fisico, i biglietti da visita e il posizionamento diretto.`)
};

const ru_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Технология динамических QR-кодов для физического брендинга, визитных карточек и прямого размещения.`)
};

const pt_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tecnologia QR dinâmica para branding físico, cartões de visita e colocação direta.`)
};

const ko_dynamic_qr_technology_for_phys = /** @type {(inputs: Dynamic_Qr_Technology_For_PhysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실물 브랜딩, 명함 및 직접 배치를 위한 다이내믹 QR 기술.`)
};

/**
* | output |
* | --- |
* | "Dynamic QR technology for physical branding, business cards, and direct placement." |
*
* @param {Dynamic_Qr_Technology_For_PhysInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const dynamic_qr_technology_for_phys = /** @type {((inputs?: Dynamic_Qr_Technology_For_PhysInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dynamic_Qr_Technology_For_PhysInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dynamic_qr_technology_for_phys(inputs)
	if (locale === "es") return es_dynamic_qr_technology_for_phys(inputs)
	if (locale === "fr") return fr_dynamic_qr_technology_for_phys(inputs)
	if (locale === "de") return de_dynamic_qr_technology_for_phys(inputs)
	if (locale === "ja") return ja_dynamic_qr_technology_for_phys(inputs)
	if (locale === "zh") return zh_dynamic_qr_technology_for_phys(inputs)
	if (locale === "ar") return ar_dynamic_qr_technology_for_phys(inputs)
	if (locale === "id") return id_dynamic_qr_technology_for_phys(inputs)
	if (locale === "it") return it_dynamic_qr_technology_for_phys(inputs)
	if (locale === "ru") return ru_dynamic_qr_technology_for_phys(inputs)
	if (locale === "pt") return pt_dynamic_qr_technology_for_phys(inputs)
	return ko_dynamic_qr_technology_for_phys(inputs)
});